module.exports = __webpack_public_path__ + "static/img/index_banner.b724024.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index_banner.jpg
// module id = hSs0
// module chunks = 0